import styles from './styles.module.scss'

export const HoldStatus = () => <div className={styles.status}>HOLD</div>
